'use client';

import { useSearchParams } from 'next/navigation';
import { FC, useState } from 'react';
import toast from 'react-hot-toast';

import { UNSUBSCRIBE_URL } from '@/api/config';
import { postRequest } from '@/api/utils/request';
import Portal from '@/components/core/Portal';
import { useTranslation } from '@/hooks/useTranslations';

import Toaster from '../Toaster';
import './styles.scss';

interface UnsubscribeProps {
  onClose: () => void;
}

const UnsubscribePopup: FC<UnsubscribeProps> = ({ onClose }) => {
  const { t } = useTranslation();
  const searchParams = useSearchParams();

  const handleConfirm = () => {
    postRequest(UNSUBSCRIBE_URL, {
      unsubscribeToken: searchParams.get('unsubscribeToken'),
    })
      .then(() => {
        onClose();
        toast(<Toaster type="success" description="" />, {
          duration: 3000,
        });
      })
      .catch(() => {
        toast(<Toaster type="error" description="Errormessage-Text" />, {
          duration: 3000,
        });
      });
  };

  const handleDeny = () => {
    onClose();
  };

  return (
    <Portal id="modal-container">
      <div className="popupWrp">
        <div className="popupInner disclaimer">
          <div className="disclaimer-popup-content">
            {/* <div className="close-disclaimer-popup-block">
              <i className="bc-i-close close-disclaimer-icon" />
            </div> */}
            <div className="disclaimer-popup-info">
              <p className="disclaimer-popup-title">{t('Subscription-button')}</p>
              <p className="disclaimer-popup-desc">{t('Unsubscribe-Text')}</p>
            </div>
            <div className="disclaimer-pop-btn-wrp">
              <button onClick={handleConfirm} className="button btnTypeBig fullWidth btnTypeGreen">
                <p>{t('Unsubscribe-Button-Text')}</p>
              </button>
              <button
                onClick={handleDeny}
                className="button btnTypeBig fullWidth btnTypeTransparent"
              >
                <p> {t('Cancel-Text')} </p>
              </button>
            </div>
          </div>
        </div>
      </div>
    </Portal>
  );
};

export default UnsubscribePopup;
